/* ===========================================
   BAU HEADER · interactions
   - mobile drawer
   - cart drawer (AJAX)
   - search overlay (predictive search)
   - sticky shrink on scroll
   - megamenu hover assist
   =========================================== */

(function() {
  'use strict';

  // ----- Body scroll lock (iOS-safe con position:fixed + restore) -----
  var bodyScrollLockY = 0;
  function lockBody() {
    if (!document.body.classList.contains('bau-no-scroll')) {
      bodyScrollLockY = window.scrollY || window.pageYOffset || 0;
      document.body.style.top = '-' + bodyScrollLockY + 'px';
    }
    document.body.classList.add('bau-no-scroll');
  }
  function unlockBody() {
    if (!anyOverlayOpen()) {
      document.body.classList.remove('bau-no-scroll');
      document.body.style.top = '';
      window.scrollTo(0, bodyScrollLockY);
    }
  }
  function anyOverlayOpen() {
    return document.querySelector('[data-mobile-drawer][aria-hidden="false"]') ||
           document.querySelector('[data-cart-drawer][aria-hidden="false"]') ||
           document.querySelector('[data-search-overlay][aria-hidden="false"]');
  }

  // ----- Mobile drawer -----
  var mdrawer = document.querySelector('[data-mobile-drawer]');
  function openMDrawer() {
    if (!mdrawer) return;
    mdrawer.setAttribute('aria-hidden', 'false');
    document.querySelectorAll('[data-open-drawer]').forEach(function(b) { b.setAttribute('aria-expanded', 'true'); });
    lockBody();
  }
  function closeMDrawer() {
    if (!mdrawer) return;
    mdrawer.setAttribute('aria-hidden', 'true');
    document.querySelectorAll('[data-open-drawer]').forEach(function(b) { b.setAttribute('aria-expanded', 'false'); });
    unlockBody();
  }
  document.querySelectorAll('[data-open-drawer]').forEach(function(btn) {
    btn.addEventListener('click', openMDrawer);
  });
  document.querySelectorAll('[data-close-drawer]').forEach(function(btn) {
    btn.addEventListener('click', closeMDrawer);
  });

  // Submenu toggles inside mobile drawer
  document.querySelectorAll('[data-mdrawer-toggle]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.closest('.bau-mdrawer-item');
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      item.classList.toggle('is-open');
    });
  });

  // Search button inside mobile drawer
  var searchFromDrawer = document.querySelector('[data-open-search-from-drawer]');
  if (searchFromDrawer) {
    searchFromDrawer.addEventListener('click', function() {
      closeMDrawer();
      setTimeout(openSearch, 250);
    });
  }

  // ----- Search overlay -----
  var soverlay = document.querySelector('[data-search-overlay]');
  var sinput = document.querySelector('[data-search-input]');
  var sresults = document.querySelector('[data-search-results]');
  var sdebounce = null;

  function openSearch() {
    if (!soverlay) return;
    soverlay.setAttribute('aria-hidden', 'false');
    document.querySelectorAll('[data-open-search]').forEach(function(b) { b.setAttribute('aria-expanded', 'true'); });
    lockBody();
    setTimeout(function() { if (sinput) sinput.focus(); }, 250);
  }
  function closeSearch() {
    if (!soverlay) return;
    soverlay.setAttribute('aria-hidden', 'true');
    document.querySelectorAll('[data-open-search]').forEach(function(b) { b.setAttribute('aria-expanded', 'false'); });
    unlockBody();
  }
  document.querySelectorAll('[data-open-search]').forEach(function(btn) {
    btn.addEventListener('click', openSearch);
  });
  document.querySelectorAll('[data-close-search]').forEach(function(btn) {
    btn.addEventListener('click', closeSearch);
  });

  // Predictive search
  if (sinput && sresults) {
    sinput.addEventListener('input', function() {
      var q = sinput.value.trim();
      clearTimeout(sdebounce);
      if (q.length < 2) {
        sresults.innerHTML = '<div class="bau-soverlay-hint">Empieza a escribir para ver resultados.</div>';
        return;
      }
      sdebounce = setTimeout(function() { runPredictive(q); }, 200);
    });
  }

  function runPredictive(q) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) {
          sresults.innerHTML = '<div class="bau-soverlay-hint">No encontramos resultados para "' + escapeHTML(q) + '".</div>';
          return;
        }
        var html = '<div class="bau-soverlay-result-list">';
        products.forEach(function(p) {
          var img = p.image || (p.featured_image && p.featured_image.url) || '';
          html += '<a href="' + p.url + '" class="bau-soverlay-result">' +
            '<div class="bau-soverlay-result-img">' + (img ? '<img src="' + img + '" alt="' + escapeHTML(p.title) + '" loading="lazy">' : '') + '</div>' +
            '<div class="bau-soverlay-result-info">' +
              '<div class="bau-soverlay-result-title">' + escapeHTML(p.title) + '</div>' +
              '<div class="bau-soverlay-result-price">' + (p.price || '') + '</div>' +
            '</div>' +
          '</a>';
        });
        html += '</div>';
        html += '<a class="bau-soverlay-result-view-all" href="/search?q=' + encodeURIComponent(q) + '&type=product">Ver todos los resultados</a>';
        sresults.innerHTML = html;
      })
      .catch(function() {
        sresults.innerHTML = '<div class="bau-soverlay-hint">Error al buscar. Intenta de nuevo.</div>';
      });
  }

  function escapeHTML(s) {
    return String(s).replace(/[&<>"']/g, function(c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  // ----- Cart drawer -----
  var cdrawer = document.querySelector('[data-cart-drawer]');
  var cartFocusTrapBound = null;

  function openCart() {
    if (!cdrawer) return;
    cdrawer.setAttribute('aria-hidden', 'false');
    document.querySelectorAll('[data-open-cart]').forEach(function(b) { b.setAttribute('aria-expanded', 'true'); });
    lockBody();
    // Focus trap: enfoca el primer elemento focusable del panel
    setTimeout(function() {
      var closeBtn = cdrawer.querySelector('[data-close-cart]');
      if (closeBtn && typeof closeBtn.focus === 'function') closeBtn.focus();
    }, 100);
    if (!cartFocusTrapBound) {
      cartFocusTrapBound = handleCartFocusTrap;
      document.addEventListener('keydown', cartFocusTrapBound);
    }
  }
  function closeCart() {
    if (!cdrawer) return;
    cdrawer.setAttribute('aria-hidden', 'true');
    document.querySelectorAll('[data-open-cart]').forEach(function(b) { b.setAttribute('aria-expanded', 'false'); });
    unlockBody();
    if (cartFocusTrapBound) {
      document.removeEventListener('keydown', cartFocusTrapBound);
      cartFocusTrapBound = null;
    }
  }

  function handleCartFocusTrap(e) {
    if (e.key !== 'Tab') return;
    if (!cdrawer || cdrawer.getAttribute('aria-hidden') === 'true') return;
    var focusables = cdrawer.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  // Toast helper para mostrar mensajes dentro del drawer (errores, avisos)
  var toastTimeout = null;
  function showCartToast(message, type) {
    var toast = document.querySelector('[data-cart-toast]');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.remove('is-error', 'is-success', 'is-warning', 'is-visible');
    toast.classList.add('is-visible');
    if (type) toast.classList.add('is-' + type);
    if (toastTimeout) clearTimeout(toastTimeout);
    toastTimeout = setTimeout(function() {
      toast.classList.remove('is-visible');
    }, 4500);
  }
  document.querySelectorAll('[data-open-cart]').forEach(function(btn) {
    btn.addEventListener('click', openCart);
  });
  document.querySelectorAll('[data-close-cart]').forEach(function(btn) {
    btn.addEventListener('click', closeCart);
  });

  // ----- Cart actions (AJAX) -----
  function getKey(el) {
    var item = el.closest('[data-cart-item]');
    return item ? item.getAttribute('data-key') : null;
  }

  function refreshCart() {
    return fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        updateCounts(cart.item_count);
        updateSubtotal(cart.total_price);
        return fetch('/?section_id=' + getCartDrawerSectionId()).catch(function() { return null; });
      });
  }

  function updateCounts(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function(el) {
      el.textContent = n;
      if (n === 0) el.classList.add('is-empty'); else el.classList.remove('is-empty');
    });
    var dc = document.querySelector('[data-cart-drawer-count]');
    if (dc) dc.textContent = '(' + n + ')';
  }

  function updateSubtotal(price) {
    var el = document.querySelector('[data-cart-subtotal]');
    if (!el) return;
    el.textContent = formatMoney(price);
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + parts.join('.') + ' MXN';
  }

  function getCartDrawerSectionId() {
    // Used for future section refresh — fallback null
    return null;
  }

  // Reload drawer markup by fetching cart.js + re-rendering minimal body
  function reloadDrawerBody() {
    return fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      lastCartSnapshot = cart;
      updateCounts(cart.item_count);
      var body = document.querySelector('[data-cart-drawer-body]');
      var itemsWrap = document.querySelector('[data-cart-items-wrap]');
      var foot = document.querySelector('[data-cart-drawer-foot]');

      var xsWrap = document.querySelector('[data-cart-crosssell-wrap]');

      if (cart.item_count === 0) {
        // Carrito vacío: items wrap → empty state, cross-sell oculto
        if (itemsWrap) {
          itemsWrap.innerHTML = renderEmptyCart();
        } else if (body) {
          body.innerHTML = '<div data-cart-items-wrap>' + renderEmptyCart() + '</div>' + (body.contains(xsWrap) ? '' : '');
        }
        if (xsWrap) xsWrap.setAttribute('hidden', '');
        if (foot) foot.innerHTML = '';
      } else {
        var html = '<ul class="bau-cdrawer-items">';
        cart.items.forEach(function(item) {
          html += renderCartItem(item);
        });
        html += '</ul>';

        if (itemsWrap) {
          itemsWrap.innerHTML = html;
        } else if (body) {
          body.innerHTML = '<div data-cart-items-wrap>' + html + '</div>';
        }
        attachQtyListeners();

        if (xsWrap) xsWrap.removeAttribute('hidden');

        if (foot) {
          foot.innerHTML = renderFoot(cart);
        }
      }

      // === Progress bar + auto-gift + discount ===
      updateProgressBar(cart);
      handleAutoGift(cart);
      renderDiscountSection(cart);

      return cart;
    });
  }

  // ===== PROGRESS BAR & AUTO-GIFT =====
  var giftProcessing = false;
  var prevUnlocked = { s1: false, s2: false, s3: false };

  function getProgressEl() { return document.querySelector('[data-bau-progress]'); }

  function getStages() {
    var el = getProgressEl();
    if (!el) return [];
    var stages = [];
    [1, 2, 3].forEach(function(i) {
      var enabled = el.getAttribute('data-stage' + i + '-enabled');
      if (enabled !== 'true') return;
      stages.push({
        n: i,
        threshold: parseInt(el.getAttribute('data-stage' + i + '-threshold'), 10) * 100, // pesos → centavos
        label: el.getAttribute('data-stage' + i + '-label') || '',
        icon: el.getAttribute('data-stage' + i + '-icon') || '★',
        giftId: i === 2 ? (el.getAttribute('data-stage2-gift-id') || '') : ''
      });
    });
    return stages;
  }

  function getNonGiftSubtotal(cart) {
    // Usamos cart.total_price (ya incluye line-level y cart-level discounts).
    // Restamos el valor del item regalo si existe (típicamente $0, pero por si acaso).
    var giftValue = 0;
    cart.items.forEach(function(item) {
      if (item.properties && item.properties._bau_gift === 'true') {
        giftValue += item.final_line_price;
      }
    });
    return cart.total_price - giftValue;
  }

  function findGiftItem(cart, giftVariantId) {
    var gid = parseInt(giftVariantId, 10);
    if (!gid) return null;
    return cart.items.find(function(it) {
      return it.variant_id === gid && it.properties && it.properties._bau_gift === 'true';
    });
  }

  function renderStagesMarkers(stages, subtotal) {
    var container = document.querySelector('[data-progress-stages]');
    if (!container) return;
    var html = '';
    stages.forEach(function(stage, idx) {
      var leftPct = ((idx + 1) / stages.length) * 100;
      var unlocked = subtotal >= stage.threshold;
      var edgeClass = '';
      if (leftPct >= 99) edgeClass = ' is-edge-right';
      else if (leftPct <= 1) edgeClass = ' is-edge-left';
      html += '<div class="bau-cdrawer-progress-stage' + (unlocked ? ' is-unlocked' : '') + edgeClass + '" style="left:' + leftPct + '%;">' +
        '<div class="bau-cdrawer-progress-stage-dot">' +
          '<span class="bau-cdrawer-progress-stage-icon">' + (unlocked ? '✓' : stage.icon) + '</span>' +
        '</div>' +
        '<div class="bau-cdrawer-progress-stage-label">' + escapeHTML(stage.label) + '</div>' +
      '</div>';
    });
    container.innerHTML = html;
  }

  function calcFillPercent(subtotal, stages) {
    if (!stages.length) return 0;
    var segPct = 100 / stages.length;
    for (var i = 0; i < stages.length; i++) {
      var prevThresh = i === 0 ? 0 : stages[i - 1].threshold;
      var thisThresh = stages[i].threshold;
      if (subtotal < thisThresh) {
        var segProgress = (subtotal - prevThresh) / (thisThresh - prevThresh);
        return segPct * i + segPct * segProgress;
      }
    }
    return 100;
  }

  function getProgressMessage(subtotal, stages) {
    // Find latest unlocked stage (to confirm achievement)
    var lastUnlocked = null;
    for (var j = 0; j < stages.length; j++) {
      if (subtotal >= stages[j].threshold) lastUnlocked = stages[j];
      else break;
    }
    // Find next stage to unlock
    for (var i = 0; i < stages.length; i++) {
      if (subtotal < stages[i].threshold) {
        var falta = stages[i].threshold - subtotal;
        var prefix = '';
        if (lastUnlocked) {
          prefix = '<span class="bau-cdrawer-progress-unlocked">✓ ' + escapeHTML(lastUnlocked.label) + '</span> · ';
        }
        return prefix + 'Te faltan <strong>' + formatMoney(falta) + '</strong> para ' + stages[i].label + ' ' + stages[i].icon;
      }
    }
    return '¡Desbloqueaste todos los beneficios! 🎉';
  }

  function updateProgressBar(cart) {
    var el = getProgressEl();
    if (!el) return;
    var stages = getStages();
    if (!stages.length) return;

    var subtotal = getNonGiftSubtotal(cart);
    var fillPct = calcFillPercent(subtotal, stages);
    var fill = document.querySelector('[data-progress-fill]');
    if (fill) fill.style.width = fillPct + '%';

    renderStagesMarkers(stages, subtotal);

    var msgEl = document.querySelector('[data-progress-msg] .bau-cdrawer-progress-msg-text');
    if (msgEl) msgEl.innerHTML = getProgressMessage(subtotal, stages);

    // Estado complete cuando todos los stages están desbloqueados
    var allUnlocked = stages.every(function(stage) { return subtotal >= stage.threshold; });
    if (allUnlocked) el.classList.add('is-complete');
    else el.classList.remove('is-complete');

    // Trigger celebración cuando se desbloquea un nuevo stage
    stages.forEach(function(stage) {
      var key = 's' + stage.n;
      var nowUnlocked = subtotal >= stage.threshold;
      if (nowUnlocked && !prevUnlocked[key]) {
        celebrateStage(stage.n);
      }
      prevUnlocked[key] = nowUnlocked;
    });
  }

  function celebrateStage(n) {
    var el = getProgressEl();
    if (!el) return;
    el.classList.add('is-celebrating');
    setTimeout(function() { el.classList.remove('is-celebrating'); }, 1200);
  }

  function handleAutoGift(cart) {
    if (giftProcessing) return;
    var el = getProgressEl();
    if (!el) return;
    if (el.getAttribute('data-stage2-enabled') !== 'true') return;
    var giftId = el.getAttribute('data-stage2-gift-id');
    if (!giftId) return;
    var threshold = parseInt(el.getAttribute('data-stage2-threshold'), 10) * 100;

    var subtotal = getNonGiftSubtotal(cart);
    var existingGift = findGiftItem(cart, giftId);

    if (subtotal >= threshold && !existingGift) {
      // Auto-add
      giftProcessing = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: parseInt(giftId, 10),
            quantity: 1,
            properties: { '_bau_gift': 'true' }
          }]
        })
      }).then(function() {
        giftProcessing = false;
        reloadDrawerBody();
      }).catch(function() { giftProcessing = false; });
    } else if (subtotal < threshold && existingGift) {
      // Auto-remove
      giftProcessing = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: existingGift.key, quantity: 0 })
      }).then(function() {
        giftProcessing = false;
        reloadDrawerBody();
      }).catch(function() { giftProcessing = false; });
    }
  }

  // ===== DISCOUNT CODE (validación real vía /cart/update.js con discount param) =====
  function getAppliedDiscounts(cart) {
    // Devolvemos TODOS los códigos manuales aplicados (puede haber más de uno).
    // Los descuentos automáticos NO aparecen en esta sección — se reflejan en el total del footer.
    if (!cart.cart_level_discount_applications) return [];
    return cart.cart_level_discount_applications
      .filter(function(d) { return d.type === 'discount_code'; })
      .map(function(d) { return { code: d.title, amount: d.total_allocated_amount || 0 }; });
  }

  function applyDiscount(code) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: code })
    }).then(function(r) { return r.json(); });
  }

  function clearDiscount() {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: '' })
    }).then(function(r) { return r.json(); });
  }

  function renderDiscountSection(cart) {
    var el = document.querySelector('[data-bau-discount]');
    if (!el) return;
    var applied = getAppliedDiscounts(cart);
    var hasMultiple = applied.length > 1;

    var html = '';
    applied.forEach(function(disc) {
      var safeCode = escapeHTML(disc.code);
      var amountText = '−' + formatMoney(disc.amount);
      // Si hay múltiples códigos, el X de cada pill se oculta y mostramos un "Quitar todos" abajo
      var removeBtn = hasMultiple ? '' :
        '<button type="button" class="bau-cdrawer-discount-remove" data-discount-remove aria-label="Quitar código" title="Quitar código">' +
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg>' +
        '</button>';
      html += '<div class="bau-cdrawer-discount-applied">' +
        '<div class="bau-cdrawer-discount-applied-info">' +
          '<span class="bau-cdrawer-discount-applied-check">✓</span>' +
          '<span class="bau-cdrawer-discount-applied-code">' + safeCode + '</span>' +
          '<span class="bau-cdrawer-discount-applied-label">· ' + amountText + '</span>' +
        '</div>' +
        removeBtn +
      '</div>';
    });

    if (hasMultiple) {
      html += '<button type="button" class="bau-cdrawer-discount-remove-all" data-discount-remove aria-label="Quitar todos los códigos">Quitar todos</button>';
    }

    // El input siempre está visible para poder añadir códigos adicionales (estilo secundario si ya hay uno)
    var formClass = applied.length > 0 ? ' is-secondary' : '';
    var placeholder = applied.length > 0 ? '¿Otro código?' : 'Código de descuento';
    html += '<form class="bau-cdrawer-discount-form' + formClass + '" data-discount-form novalidate>' +
      '<input type="text" class="bau-cdrawer-discount-input" data-discount-input placeholder="' + placeholder + '" autocomplete="off" autocapitalize="characters" spellcheck="false">' +
      '<button type="submit" class="bau-cdrawer-discount-apply">Aplicar</button>' +
    '</form>' +
    '<div class="bau-cdrawer-discount-note" data-discount-note></div>';

    el.innerHTML = html;
    attachDiscountListeners();
  }

  function showDiscountError(msg) {
    var note = document.querySelector('[data-discount-note]');
    if (note) {
      note.textContent = msg;
      note.classList.add('is-error');
    }
  }

  function attachDiscountListeners() {
    var form = document.querySelector('[data-discount-form]');
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var input = form.querySelector('[data-discount-input]');
        var code = (input.value || '').trim();
        if (!code) return;
        var btn = form.querySelector('.bau-cdrawer-discount-apply');
        if (btn) {
          btn.disabled = true;
          btn.innerHTML = '<svg class="bau-cdrawer-discount-spinner" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9" stroke-dasharray="40 20"/></svg>';
        }

        // Capturar códigos aplicados ANTES para detectar si el nuevo se agregó o reemplazó otro
        fetch('/cart.js').then(function(r) { return r.json(); }).then(function(prevCart) {
          var prevApplied = getAppliedDiscounts(prevCart).map(function(d) { return d.code.toUpperCase(); });
          var codeUpper = code.toUpperCase();

          // Si el código ya estaba aplicado, avisamos sin gastar request
          if (prevApplied.indexOf(codeUpper) !== -1) {
            if (btn) { btn.disabled = false; btn.textContent = 'Aplicar'; }
            showDiscountError('Ese código ya está aplicado.');
            return;
          }

          return applyDiscount(code).then(function() {
            return fetch('/cart.js').then(function(r) { return r.json(); });
          }).then(function(cart) {
            var nowApplied = getAppliedDiscounts(cart);
            var nowCodes = nowApplied.map(function(d) { return d.code.toUpperCase(); });
            var newCodeApplied = nowCodes.indexOf(codeUpper) !== -1;

            if (newCodeApplied) {
              // Detectar si el nuevo código REEMPLAZÓ uno anterior (Shopify no permitió combinar)
              var replacedCodes = prevApplied.filter(function(c) { return nowCodes.indexOf(c) === -1; });

              lastCartSnapshot = cart;
              updateCounts(cart.item_count);
              updateSubtotal(cart.total_price);
              renderDiscountSection(cart);
              updateFootDiscount(cart);
              updateProgressBar(cart);
              handleAutoGift(cart);
              reloadDrawerBody();

              if (replacedCodes.length > 0) {
                // Avisar en el note
                setTimeout(function() {
                  var noteEl = document.querySelector('[data-discount-note]');
                  if (noteEl) {
                    noteEl.textContent = code.toUpperCase() + ' reemplazó ' + replacedCodes.join(', ') + ' (no son combinables).';
                    noteEl.classList.remove('is-error');
                    noteEl.classList.add('is-warning');
                  }
                }, 100);
              }
            } else {
              // Inválido o no se aplicó: mantener form, mostrar error
              if (btn) { btn.disabled = false; btn.textContent = 'Aplicar'; }
              showDiscountError('Código inválido o no se pudo aplicar.');
            }
          });
        }).catch(function() {
          if (btn) { btn.disabled = false; btn.textContent = 'Aplicar'; }
          showDiscountError('No pudimos validar el código. Intenta de nuevo.');
        });
      });
    }
    var removeBtn = document.querySelector('[data-discount-remove]');
    if (removeBtn) {
      removeBtn.addEventListener('click', function() {
        clearDiscount().then(function() {
          return fetch('/cart.js').then(function(r) { return r.json(); });
        }).then(function(cart) {
          updateCounts(cart.item_count);
          updateSubtotal(cart.total_price);
          renderDiscountSection(cart);
          updateFootDiscount(cart);
          updateProgressBar(cart);
          handleAutoGift(cart);
        });
      });
    }
  }

  function updateFootDiscount(cart) {
    var foot = document.querySelector('[data-cart-drawer-foot]');
    if (!foot || cart.item_count === 0) return;
    foot.innerHTML = renderFoot(cart);
  }

  attachDiscountListeners();

  // ===== CROSS-SELL QUICK-ADD =====
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-xs-add]');
    if (!btn) return;
    if (btn.classList.contains('is-loading')) return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var label = btn.querySelector('.bau-cdrawer-xs-add-label');
    btn.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    }).then(function(r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function() {
      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      if (label) label.textContent = '¡Agregado!';
      // Remover la card con fade
      var card = btn.closest('[data-xs-card]');
      if (card) {
        setTimeout(function() {
          card.style.transition = 'opacity 0.3s ease, max-width 0.3s ease, margin 0.3s ease, padding 0.3s ease';
          card.style.opacity = '0';
          card.style.maxWidth = '0';
          card.style.margin = '0';
          card.style.padding = '0';
          card.style.overflow = 'hidden';
          setTimeout(function() {
            card.parentNode && card.parentNode.removeChild(card);
            reloadDrawerBody();
          }, 320);
        }, 500);
      } else {
        reloadDrawerBody();
      }
    }).catch(function() {
      btn.classList.remove('is-loading');
      if (label) label.textContent = 'Error · Reintentar';
    });
  });

  // Inicializar barra al cargar la página
  document.addEventListener('DOMContentLoaded', function() {
    if (getProgressEl()) {
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        updateProgressBar(cart);
        handleAutoGift(cart);
      });
    }
  });

  function renderEmptyCart() {
    return '<div class="bau-cdrawer-empty">' +
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="M5 7h14l-1.5 11a2 2 0 0 1-2 1.7H8.5a2 2 0 0 1-2-1.7L5 7z"></path><path d="M9 7V5a3 3 0 0 1 6 0v2"></path></svg>' +
      '<p class="bau-cdrawer-empty-title">Tu carrito está vacío</p>' +
      '<p class="bau-cdrawer-empty-sub">Echa un vistazo al catálogo y dale algo bueno a tu perro.</p>' +
      '<a href="/collections/all" class="bau-cdrawer-empty-btn">Ver productos</a>' +
    '</div>';
  }

  // Suma el precio "original" de items que NO son regalo. Considera compare_at_price.
  // Se usa para el strike del CTA — refleja el MSRP real que pagaría el cliente sin descuentos.
  function getCartOriginalTotal(cart) {
    if (!cart || !cart.items) return 0;
    var total = 0;
    cart.items.forEach(function(it) {
      if (it.properties && it.properties._bau_gift === 'true') return;
      var compareAtLine = (it.compare_at_price && it.compare_at_price > it.price)
        ? it.compare_at_price * it.quantity
        : 0;
      total += Math.max(compareAtLine, it.original_line_price);
    });
    return total;
  }

  // Calcula el precio efectivo de un item considerando:
  //  · Descuentos line-level (product-specific): ya están en item.final_line_price
  //  · Descuentos cart-level (order-wide): NO están en item.final_line_price, se prorratean
  // El denominador del prorrateo EXCLUYE los items de regalo (_bau_gift) para que
  // la matemática del descuento per-item refleje el % real aplicado.
  function getEffectiveLineFinal(item, cart) {
    if (!cart) return item.final_line_price;

    var totalAllocatedToLines = 0;
    var discountDenominator = 0;
    cart.items.forEach(function(it) {
      totalAllocatedToLines += (it.original_line_price - it.final_line_price);
      var itIsGift = it.properties && it.properties._bau_gift === 'true';
      if (!itIsGift) {
        discountDenominator += it.line_price;
      }
    });
    var unallocatedDiscount = (cart.total_discount || 0) - totalAllocatedToLines;
    if (unallocatedDiscount < 0) unallocatedDiscount = 0;

    var isGift = item.properties && item.properties._bau_gift === 'true';
    var itemPortion = 0;
    if (unallocatedDiscount > 0 && discountDenominator > 0 && !isGift) {
      var share = item.line_price / discountDenominator;
      itemPortion = unallocatedDiscount * share;
    }

    return Math.max(0, item.final_line_price - itemPortion);
  }

  // Variable global del cart actual (para que renderCartItem tenga acceso al cart completo)
  var lastCartSnapshot = null;

  function renderCartItem(item) {
    var isGift = item.properties && item.properties._bau_gift === 'true';

    // Calcular precio "original" considerando compare_at_price del variant
    var compareAtLine = 0;
    if (item.compare_at_price && item.compare_at_price > item.price) {
      compareAtLine = item.compare_at_price * item.quantity;
    }
    var originalPrice = Math.max(compareAtLine, item.original_line_price);

    // Precio efectivo: incluye line-level + cart-level (prorrata)
    var effectiveFinal = lastCartSnapshot
      ? getEffectiveLineFinal(item, lastCartSnapshot)
      : item.final_line_price;

    var hasDiscount = !isGift && originalPrice > effectiveFinal;
    var savedAmount = originalPrice - effectiveFinal;

    var img = item.image ? '<img src="' + item.image + '&width=200" alt="' + escapeHTML(item.product_title) + '" width="80" height="80" loading="lazy">' : '';
    var variant = (item.variant_title && item.variant_title.indexOf('Default') === -1) ? '<p class="bau-cdrawer-item-variant">' + escapeHTML(item.variant_title) + '</p>' : '';

    var priceBlock;
    if (isGift) {
      priceBlock = '<div class="bau-cdrawer-item-price-block">' +
        '<span class="bau-cdrawer-item-price-old">' + formatMoney(originalPrice) + '</span>' +
        '<span class="bau-cdrawer-item-gift-pill">¡GRATIS!</span>' +
      '</div>';
    } else if (hasDiscount) {
      priceBlock = '<div class="bau-cdrawer-item-price-block">' +
        '<span class="bau-cdrawer-item-price-old">' + formatMoney(originalPrice) + '</span>' +
        '<span class="bau-cdrawer-item-price bau-cdrawer-item-price--sale">' + formatMoney(effectiveFinal) + '</span>' +
        '<span class="bau-cdrawer-item-savings">Ahorras ' + formatMoney(savedAmount) + '</span>' +
      '</div>';
    } else {
      priceBlock = '<span class="bau-cdrawer-item-price">' + formatMoney(effectiveFinal) + '</span>';
    }

    var qtyBlock = isGift ? '' :
      '<div class="bau-cdrawer-qty" data-qty-control>' +
        '<button type="button" data-qty-decr aria-label="Disminuir cantidad">−</button>' +
        '<span class="bau-cdrawer-qty-num" data-qty-num>' + item.quantity + '</span>' +
        '<button type="button" data-qty-incr aria-label="Aumentar cantidad">+</button>' +
      '</div>';

    return '<li class="bau-cdrawer-item" data-cart-item data-key="' + item.key + '"' + (isGift ? ' data-bau-gift' : '') + (hasDiscount ? ' data-discounted' : '') + '>' +
      '<a href="' + item.url + '" class="bau-cdrawer-item-img">' + img + '</a>' +
      '<div class="bau-cdrawer-item-info">' +
        '<a href="' + item.url + '" class="bau-cdrawer-item-title">' + escapeHTML(item.product_title) + '</a>' +
        variant +
        '<div class="bau-cdrawer-item-bottom">' +
          qtyBlock +
          priceBlock +
        '</div>' +
      '</div>' +
      (isGift ? '' : '<button class="bau-cdrawer-item-remove" type="button" data-cart-remove aria-label="Eliminar">' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"></line><line x1="18" y1="6" x2="6" y2="18"></line></svg>' +
      '</button>') +
    '</li>';
  }

  function renderFoot(cart) {
    // Leer threshold y costo de envío de los data attrs del progress (configurados via theme settings)
    var progressEl = document.querySelector('[data-bau-progress]');
    var freeShippingThreshold = 0;
    var shippingEstimate = 0;
    if (progressEl) {
      if (progressEl.getAttribute('data-stage1-enabled') === 'true') {
        freeShippingThreshold = parseInt(progressEl.getAttribute('data-stage1-threshold'), 10) * 100;
      }
      shippingEstimate = parseInt(progressEl.getAttribute('data-shipping-estimate'), 10) * 100 || 0;
    }

    var isFreeShipping = freeShippingThreshold > 0 && cart.total_price >= freeShippingThreshold;
    var shippingValueHtml = isFreeShipping
      ? '<span class="bau-cdrawer-summary-value bau-cdrawer-free">¡Gratis!</span>'
      : '<span class="bau-cdrawer-summary-value">' + (shippingEstimate > 0 ? formatMoney(shippingEstimate) : 'Calculado en checkout') + '</span>';

    var summaryHtml = '<div class="bau-cdrawer-summary-line">' +
      '<span class="bau-cdrawer-summary-label">Envío</span>' +
      shippingValueHtml +
    '</div>';

    if (cart.total_discount > 0) {
      summaryHtml += '<div class="bau-cdrawer-summary-line">' +
        '<span class="bau-cdrawer-summary-label">Descuento</span>' +
        '<span class="bau-cdrawer-summary-value bau-cdrawer-discount-amount">−' + formatMoney(cart.total_discount) + '</span>' +
      '</div>';
    }

    // CTA: con strike-through del total original (NO incluye items de regalo)
    var realOriginal = getCartOriginalTotal(cart);
    var ctaInnerHtml;
    if (realOriginal > cart.total_price) {
      ctaInnerHtml = '<span class="bau-cdrawer-checkout-label">Pagar ahora</span>' +
        '<span class="bau-cdrawer-checkout-sep">·</span>' +
        '<span class="bau-cdrawer-checkout-total-old">' + formatMoney(realOriginal) + '</span>' +
        '<span class="bau-cdrawer-checkout-total">' + formatMoney(cart.total_price) + '</span>';
    } else {
      ctaInnerHtml = '<span class="bau-cdrawer-checkout-label">Pagar ahora</span>' +
        '<span class="bau-cdrawer-checkout-sep">·</span>' +
        '<span class="bau-cdrawer-checkout-total">' + formatMoney(cart.total_price) + '</span>';
    }

    return summaryHtml +
    '<form action="/cart" method="post" novalidate>' +
      '<button type="submit" name="checkout" class="bau-cdrawer-checkout">' +
        ctaInnerHtml +
      '</button>' +
    '</form>';
  }

  function attachQtyListeners() {
    document.querySelectorAll('[data-cart-item]').forEach(function(item) {
      var decr = item.querySelector('[data-qty-decr]');
      var incr = item.querySelector('[data-qty-incr]');
      var rem = item.querySelector('[data-cart-remove]');
      var num = item.querySelector('[data-qty-num]');
      var key = item.getAttribute('data-key');

      if (decr) decr.addEventListener('click', function() {
        var q = parseInt(num.textContent, 10);
        if (q > 1) updateQty(key, q - 1);
        else removeItem(key);
      });
      if (incr) incr.addEventListener('click', function() {
        var q = parseInt(num.textContent, 10);
        updateQty(key, q + 1);
      });
      if (rem) rem.addEventListener('click', function() { removeItem(key); });
    });
  }

  var qtyUpdating = false;
  function updateQty(key, qty) {
    if (qtyUpdating) return;
    qtyUpdating = true;

    // Deshabilitar TODOS los botones de qty mientras hay request en vuelo
    document.querySelectorAll('[data-cart-drawer-body] [data-qty-decr], [data-cart-drawer-body] [data-qty-incr], [data-cart-drawer-body] [data-cart-remove]').forEach(function(b) {
      b.disabled = true;
      b.style.opacity = '0.5';
      b.style.pointerEvents = 'none';
    });

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function(r) {
      if (!r.ok) return r.json().then(function(err) { throw err; });
      return r.json();
    }).then(function() {
      qtyUpdating = false;
      // reloadDrawerBody re-renderea — los botones nuevos no necesitan reset
      reloadDrawerBody();
    }).catch(function(err) {
      qtyUpdating = false;
      // En error, re-habilitar
      document.querySelectorAll('[data-cart-drawer-body] [data-qty-decr], [data-cart-drawer-body] [data-qty-incr], [data-cart-drawer-body] [data-cart-remove]').forEach(function(b) {
        b.disabled = false;
        b.style.opacity = '';
        b.style.pointerEvents = '';
      });
      var msg = (err && err.description) ? err.description : 'No pudimos actualizar la cantidad.';
      showCartToast(msg, 'error');
    });
  }
  function removeItem(key) {
    updateQty(key, 0);
  }

  attachQtyListeners();

  // ===== ADD TO CART INTERCEPTOR =====
  // Intercepta en fase de captura para ganarle a cualquier otro handler del tema.
  // Cubre tanto submit del form como click en el botón submit.
  function isAddToCartForm(form) {
    if (!form) return false;
    var action = form.action || form.getAttribute('action') || '';
    return /\/cart\/add/.test(action);
  }

  function handleAddToCart(form, btn) {
    if (!form) return;
    if (form.dataset.bauSubmitting === '1') return;
    form.dataset.bauSubmitting = '1';

    var originalLabel = null;
    if (btn) {
      originalLabel = btn.innerHTML;
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('is-loading');
    }

    // Abre el drawer inmediatamente para feedback visual instantáneo
    openCart();

    var data = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: data, headers: { 'Accept': 'application/json' } })
      .then(function(r) {
        if (!r.ok) return r.json().then(function(err) { throw err; });
        return r.json();
      })
      .then(function() {
        form.dataset.bauSubmitting = '';
        if (btn) {
          btn.removeAttribute('aria-busy');
          btn.classList.remove('is-loading');
          if (originalLabel !== null) btn.innerHTML = originalLabel;
        }
        reloadDrawerBody();
      })
      .catch(function(err) {
        form.dataset.bauSubmitting = '';
        if (btn) {
          btn.removeAttribute('aria-busy');
          btn.classList.remove('is-loading');
          if (originalLabel !== null) btn.innerHTML = originalLabel;
        }
        // Si hubo error, recargamos cart para mantener consistencia visual + mostramos toast
        reloadDrawerBody();
        var msg = (err && err.description)
          ? err.description
          : (err && err.message)
            ? err.message
            : 'No pudimos agregar el producto. Intenta de nuevo.';
        showCartToast(msg, 'error');
        if (err && err.description) console.warn('Bau cart add error:', err.description);
      });
  }

  // Click handler en CAPTURA — corre antes que cualquier otro listener del tema
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('button[type="submit"], input[type="submit"], [name="add"]');
    if (!btn) return;
    var form = btn.closest('form');
    if (!isAddToCartForm(form)) return;
    e.preventDefault();
    e.stopPropagation();
    handleAddToCart(form, btn);
  }, true);

  // Submit handler como fallback (formularios que se envían sin click — Enter en input)
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!isAddToCartForm(form)) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"], [name="add"]');
    handleAddToCart(form, btn);
  }, true);

  // ----- Sticky header shrink on scroll -----
  var header = document.querySelector('[data-bau-header]');
  if (header) {
    var lastY = 0;
    window.addEventListener('scroll', function() {
      var y = window.scrollY || window.pageYOffset;
      if (y > 60) header.classList.add('is-shrunk');
      else header.classList.remove('is-shrunk');
      lastY = y;
    }, { passive: true });
  }

  // ----- ESC key closes any open overlay -----
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      if (mdrawer && mdrawer.getAttribute('aria-hidden') === 'false') closeMDrawer();
      if (cdrawer && cdrawer.getAttribute('aria-hidden') === 'false') closeCart();
      if (soverlay && soverlay.getAttribute('aria-hidden') === 'false') closeSearch();
    }
  });

})();
